<template>
  <div>
    <div v-if="modeProp == 'button'">
      <v-list-item
        v-if="listProp"
        @click="openDialogButton"
      >
        <v-list-item-icon>
          <v-icon>{{ iconProp || 'mdi-history' }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title v-text="titleProp || $t('history')" />
      </v-list-item>
      <v-tooltip
        v-if="!listProp"
        bottom
      >
        <template
          v-slot:activator="{ on, attrs }"
        >
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="openDialogButton"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              {{ iconProp || 'mdi-history' }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ titleProp || $t('history') }}</span>
      </v-tooltip>
    </div>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="contentDialog"
      width="90%"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="contentDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          class="mt-0 pt-0 pr-7"
        >
          <log
            ref="logRef"
            :type-prop="type"
            :ref-id-prop="refId"
            :user-prop="user"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Log from './log.vue'
export default {
  name: 'TaxPayerContent',
  components: {
    Log
  },
  props: ['userProp', 'typeProp', 'refIdProp', 'modeProp', 'listProp', 'iconProp', 'titleProp'],
  data () {
    return {
      printType: 'unofficial',
      contentDialog: false,
      content: null,
      refId: null,
      type: null,
      user: null,
      product: null
    }
  },
  watch: {
    userProp (val) {
      this.user = val
    },
    refIdProp (val) {
      this.refId = val
    },
    typeProp (val) {
      this.type = val
    },
    invoiceProp (val) {
      if (this.invoiceProp && val.tax_payer) {
        this.content = JSON.parse(val.tax_payer.reponse)
      } else {
        this.content = null
      }
    }
  },
  mounted () {
    this.type = this.typeProp
    this.refId = this.refIdProp
    this.user = this.userProp
  },
  methods: {
    openDialogButton (id = null, type = null, user = null) {
      this.type = this.typeProp
      this.refId = this.refIdProp
      this.user = this.userProp
      var app = this
      setTimeout(function () {
        app.contentDialog = true
      }, 100)
    },
    openDialog (id, type, user) {
      this.type = type
      this.refId = id
      this.user = user
      var app = this
      setTimeout(function () {
        app.contentDialog = true
      }, 100)
    }
  }
}
</script>

<style scoped>

</style>
